export const MapFilters = {
  all: ['ALL'],
};

export default MapFilters;
